import { BaseModel } from 'src/app/shared/models/base.model';

export class Size extends BaseModel{
    static fromJsonToObject(jsonData:any):Size{
        return Object.assign(new Size(),jsonData);
    }
}